import { Button } from "../Button";
import { Text } from "../Text";
import s from "./UpdatePrompt.module.css";

export interface UpdatePromptProps {
  onApply: () => void;
  onDismiss: () => void;
  className?: string;
}

export function UpdatePrompt({ onApply, onDismiss, className }: UpdatePromptProps) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return (
    <div className={classes} role="status">
      <Text size="sm" weight="medium">
        Uusi versio saatavilla
      </Text>
      <div className={s.actions}>
        <Button variant="ghost" onClick={onDismiss}>
          Ei nyt
        </Button>
        <Button variant="primary" onClick={onApply}>
          Päivitä
        </Button>
      </div>
    </div>
  );
}
